import React, { useState } from "react";
import { FormLabel } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import SearchableSelect from "../Forms/SearchableSelect";
import { useTranslation } from "react-i18next";
import { scoreValues } from "../../API/config";
import { styles } from "./styles";

const ScoreFilter = (props) => {
  const { t } = useTranslation();
  const { classes, onSearchCriteriaChange } = props;

  const [score, setScore] = useState();
  const options = [
    {
      value: scoreValues.blocked,
      label: t("labels.filter.blocked"),
    },
    {
      value: scoreValues.high,
      label: t("labels.filter.high"),
    },
    {
      value: scoreValues.medium,
      label: t("labels.filter.medium"),
    },
    {
      value: scoreValues.low,
      label: t("labels.filter.low"),
    },
    {
      value: scoreValues.cannotScore,
      label: t("labels.filter.no_score"),
    },
  ];

  const handleScoreChange = async (v) => {
    setScore(v);
    if (onSearchCriteriaChange) {
      onSearchCriteriaChange({ score: v ? v.value : null });
    }
  };

  return (
    <div className={classes.filterContainer}>
      <FormLabel className={classes.headerLabel}>
        {t("labels.filter.score")}
      </FormLabel>
      <SearchableSelect
        options={options}
        value={score}
        changeHandler={handleScoreChange}
        placeholder={""}
      />
    </div>
  );
};

export default withStyles(styles, { withTheme: true })(ScoreFilter);
